import { useState } from "react";

const PAGE_SIZE_OPTIONS = [25, 50, 75, 100];

const Pagination = ({
  pageSize,
  setPageSize,
  totalCount,
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);

  const getPageNumbers = () => {
    if (totalPages <= 6) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];

    // Beginning
    if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, "…", totalPages);
      return pages;
    }

    // End
    if (currentPage >= totalPages - 3) {
      pages.push(
        1,
        "…",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );
      return pages;
    }

    // Middle
    pages.push(
      1,
      "…",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "…",
      totalPages,
    );

    return pages;
  };

  return (
    <div className="rbFooterRow">
      <div className="rbFooterLeft">
        <span className="rbShowingText">
          Showing {totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1} to{" "}
          {Math.min(currentPage * pageSize, totalCount)} of {totalCount} audits
        </span>

        <div className="rbPageSize">
          <span>Rows per page:</span>

          <div className="rbPageSizeDropdown">
            <button
              type="button"
              className="rbPageSizeSelect"
              onClick={() => setIsPageSizeOpen((prev) => !prev)}
            >
              {pageSize}
              <span className="rbPageSizeArrow">⌄</span>
            </button>

            {isPageSizeOpen && (
              <div className="rbPageSizeOptions">
                {PAGE_SIZE_OPTIONS.map((size) => (
                  <button
                    key={size}
                    type="button"
                    className={`rbPageSizeOption ${
                      pageSize === size ? "selected" : ""
                    }`}
                    onClick={() => {
                      setPageSize(size);
                      setCurrentPage(1);
                      setIsPageSizeOpen(false);
                    }}
                  >
                    {size}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="rbPagination">
        <button
          className="rbPageBtn"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
        >
          ‹
        </button>

        {getPageNumbers().map((p, idx) =>
          p === "..." ? (
            <span key={`ellipsis-${idx}`} className="rbPageEllipsis">
              …
            </span>
          ) : (
            <button
              key={p}
              className={`rbPageBtn ${currentPage === p ? "active" : ""}`}
              onClick={() => setCurrentPage(p)}
            >
              {p}
            </button>
          ),
        )}

        <button
          className="rbPageBtn"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Pagination;
